import { render, staticRenderFns } from "./cleadr.vue?vue&type=template&id=436688d4&"
import script from "./cleadr.vue?vue&type=script&lang=js&"
export * from "./cleadr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports